<template>
  <div class="container">
    <ml-table
      v-if="active === 'list'"
      title="分组管理"
      ref="groupTableRef"
      :url="$API.group_page_list_post"
      :defaultConfig="listTableConfig"
      :needCloneKeys="['sortNo']"
      :mountQuery="true"
      :indexWidth="0"
    >
      <el-table-column
        label="分组名称"
        slot="dashboardGroupName"
        prop="dashboardGroupName"
      >
        <template slot-scope="scope">
          <span class="click-word" @click="goDashboardList(scope.row)">{{
            scope.row.dashboardGroupName
          }}</span>
        </template>
      </el-table-column>
      <el-table-column slot="sortNo_clone" prop="sortNo_clone" width="100">
        <template slot="header">
          <div class="sort-table-header">
            <div>排序</div>
            <el-tooltip
              class="sort-tip"
              effect="dark"
              content="排序值相同，则默认按照发布时间倒序"
              placement="top"
            >
              <img :src="require('@/assets/images/tip.png')" />
            </el-tooltip>
          </div>
        </template>
        <template slot-scope="{ row }">
          <el-input
            type="number"
            v-model="row.sortNo_clone"
            @change="editInfo(row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        slot="operation"
        prop="operation"
        width="260"
      >
        <template slot-scope="{ row }">
          <div class="col-btn-group">
            <div class="col-btn" @click="getDetailPage('detailGroup', row)">
              详情
            </div>
            <div class="border"></div>
            <div class="col-btn" @click="getDetailPage('editGroup', row)">
              编辑
            </div>
            <div class="border"></div>
            <el-dropdown
              trigger="click"
              @command="($event) => setStatus($event, row)"
            >
              <span class="el-dropdown-link">
                {{ row.isEnable ? '显示' : '隐藏'
                }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="true">显示</el-dropdown-item>
                <el-dropdown-item :command="false">隐藏</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div class="border"></div>
            <div class="col-btn" @click="deleteItem(row)">删除</div>
          </div>
        </template>
      </el-table-column>
    </ml-table>
    <div v-else class="out-container form-container">
      <div class="sub-title">
        <div class="parent-title" @click="cancel">分组管理</div>
        <div class="line">/</div>
        <div class="current-title">
          {{
            active === 'addGroup'
              ? '新建分组'
              : active === 'editGroup'
              ? '编辑分组'
              : active === 'detailGroup'
              ? '分组详情'
              : ''
          }}
        </div>
      </div>
      <el-card class="box-card box-card-container" shadow="never">
        <el-form
          class="form-content"
          ref="form"
          :model="form"
          label-width="120px"
          :rules="rules"
        >
          <el-form-item label="分组名称" prop="dashboardGroupName">
            <el-input
              :disabled="active === 'detailGroup'"
              v-model="form.dashboardGroupName"
              placeholder="请输入分组名称, 20字以内"
              :maxlength="20"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="分组所属单位" prop="organizationId" required>
            <el-select
              style="width: 100%"
              :disabled="active === 'detailGroup'"
              v-model="form.organizationName"
              filterable
              remote
              reserve-keyword
              placeholder="请选择单位"
              :remote-method="getAllOrganization"
              :loading="loading"
              @change="changeOrganization"
            >
              <el-option
                v-for="item in organizaitionList"
                :key="item.legalPersonId"
                :label="item.organizationName"
                :value="item.legalPersonId"
                s
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分组设置" prop="isEnable" required>
            <el-radio-group v-model="form.isEnable">
              <el-radio :label="true" :disabled="active === 'detailGroup'"
                >显示</el-radio
              >
              <el-radio :label="false" :disabled="active === 'detailGroup'"
                >隐藏</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="sortNo" class="sort-form-label">
            <template slot="label">
              <div class="sort-table-header">
                分组排序
                <el-tooltip
                  class="sort-tip"
                  effect="dark"
                  content="请输入序号（1-10的正整数），序号越大排名越靠前"
                  placement="top"
                >
                  <img :src="require('@/assets/images/tip.png')" />
                </el-tooltip>
              </div>
            </template>
            <el-input
              :disabled="active === 'detailGroup'"
              type="number"
              v-model="form.sortNo"
              placeholder="请输入序号（1-10的正整数），序号越大排名越靠前"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="btn-list">
          <el-button @click="cancel">{{
            active === 'detailGroup' ? '返回' : '取消'
          }}</el-button>
          <el-button type="primary" @click="submit">{{
            active === 'detailGroup' ? '编辑' : '确定'
          }}</el-button>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
const validateSortNo = (rule, value, callback) => {
  if (!value) callback();
  if (/^\+?[1-9][0-9]*$/.test(value) === false || value > 10) {
    callback(new Error('排序请输入1至10的正整数'));
  } else callback();
};
export default {
  name: 'groupList',
  data() {
    return {
      active: 'list',
      listTableConfig: {
        columns: [
          {
            prop: 'dashboardGroupName',
            label: '分组名称',
            slot: 'dashboardGroupName',
            filter: {
              label: '分组名称',
              prop: 'dashboardGroupName',
            },
          },
          {
            prop: 'organizationName',
            label: '单位名称',
            filter: {
              label: '单位名称',
              prop: 'organizationName',
            },
          },
          {
            prop: 'sortNo_clone',
            label: '排序',
            slot: 'sortNo_clone',
          },
          {
            prop: 'realName',
            label: '更新人',
            width: '150',
          },
          {
            prop: 'updatedAt',
            label: '更新时间',
            width: '200',
          },
          {
            prop: 'operation',
            label: '操作',
            slot: 'operation',
          },
        ],
        actions: [
          {
            config: {
              type: 'primary',
              img: require('@/assets/images/add.png'),
            },
            label: '新增分组',
            click: this.addGroup,
          },
        ],
        listQuery: {
          requestSource: 'BACKGROUND_MANAGEMENT',
        },
      },
      form: {
        dashboardGroupName: '',
        organizationId: '',
        organizationName: '',
        ucEnv: '',
        isEnable: true,
        sortNo: 1,
      },
      rules: {
        dashboardGroupName: [
          { required: true, message: '请输入分组名称', trigger: 'blur' },
          { validator: this.validateName, trigger: 'blur' },
        ],
        organizationId: [
          { required: true, message: '请选择单位', trigger: 'change' },
        ],
        sortNo: [
          { required: true, message: '请输入分组排序', trigger: 'blur' },
          { validator: validateSortNo, trigger: 'blur' },
        ],
      },
      organizationKey: '',
      organizaitionList: [],
      loading: false,
      oldName: '',
      oldOrganizationId: '',
    };
  },
  filters: {},
  mounted() {},
  methods: {
    /**
     * 分组重名校验
     * */
    async validateName(rule, value, callback) {
      if (
        (this.active === 'addGroup' && this.form.organizationId) ||
        (this.active === 'editGroup' &&
          (value !== this.oldName ||
            this.form.organizationId !== this.oldOrganizationId))
      ) {
        const res = await this.$http.post(
          this.$API.check_group_name_post,
          {
            organizationId: this.form.organizationId,
            dashboardGroupName: this.form.dashboardGroupName,
          },
          {
            notLoading: true,
          },
        );
        if (res?.success) {
          if (!res.data) callback();
          else callback(new Error('分组名称不可重复'));
        } else callback(new Error('分组名称不可重复'));
      } else {
        callback();
      }
    },
    /**
     * 获取所有单位
     * **/
    async getAllOrganization(query) {
      if (!query) {
        this.organizaitionList = [];
        return;
      }
      this.loading = true;
      const res = await this.$http.post(
        this.$API.organization_list_post,
        {
          orgName: query,
        },
        {
          notLoading: true,
        },
      );
      if (res?.success) {
        this.organizaitionList = res.data;
      }
      this.loading = false;
    },
    /**
     * 切换单位
     * **/
    changeOrganization(e) {
      const organization = this.organizaitionList.find(
        (org) => org.legalPersonId === e,
      );
      if (organization.legalPersonId) {
        this.form.organizationId = organization.legalPersonId;
        this.form.organizationName = organization.organizationName;
        this.form.ucEnv = organization.userCenterEnv;
      }
      this.$refs.form.validateField('dashboardGroupName');
    },
    /**
     * 新建分组 / 详情转编辑 /  确认编辑
     * **/
    submit() {
      if (this.active === 'addGroup') {
        // 新增
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.$http
              .post(this.$API.add_group_post, { ...this.form })
              .then(() => {
                this.cancel();
              });
          }
        });
      }
      if (this.active === 'editGroup') {
        // 编辑
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.editInfo(this.form);
          }
        });
      }
      if (this.active === 'detailGroup') {
        // 详情
        this.active = 'editGroup';
      }
    },
    /*
     * 更新仪表盘组
     * **/
    async editInfo(row) {
      if (this.active === 'list' && row.sortNo !== row.sortNo_clone) {
        let message = '';
        if (
          !row.sortNo_clone ||
          /^\+?[1-9][0-9]*$/.test(row.sortNo_clone) === false ||
          row.sortNo_clone > 10
        ) {
          message = '排序请输入1至10的正整数';
        }
        if (message) {
          this.$message.info(message);
          row.sortNo_clone = row.sortNo;
          return;
        }
        row.sortNo = row.sortNo_clone;
      }
      const res = await this.$http.post(this.$API.group_page_edit_post, {
        ...row,
      });
      if (res?.success && this.active === 'list')
        await this.$refs.groupTableRef.getList();
      if (res?.success && this.active === 'editGroup') this.cancel();
    },
    /**
     * 更新状态  显示/隐藏
     * **/
    setStatus(val, row) {
      if (val === row.isEnable) return;
      row.isEnable = val;
      this.editInfo(row);
    },
    /**
     * 删除
     * **/
    async deleteItem(row) {
      this.$confirm(
        '删除后，分组及分组下的仪表盘也将被删除，确认删除？',
        '提示',
        {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
        },
      ).then(() => {
        this.$http
          .post(this.$API.group_delete_post, { id: row.id })
          .then(() => {
            this.$refs.groupTableRef.getList();
          });
      });
    },
    /**
     * 新建分组
     * **/
    addGroup() {
      this.active = 'addGroup';
    },
    getDetailPage(active, row) {
      this.active = active;
      if (row) this.form = JSON.parse(JSON.stringify(row));
      this.oldName = this.form.dashboardGroupName;
      this.oldOrganizationId = this.form.organizationId;
      this.getAllOrganization(this.form.organizationName);
    },
    /**
     * 回到列表页面
     * */
    cancel() {
      this.form = {
        dashboardGroupName: '',
        organizationId: '',
        organizationName: '',
        ucEnv: '',
        isEnable: true,
        sortNo: 1,
      };
      this.oldName = '';
      this.oldOrganizationId = '';
      this.organizaitionList = [];
      this.active = 'list';
    },
    goDashboardList(row) {
      this.$router.push({
        name: 'dashboardListByGroup',
        query: {
          groupId: row.id,
          dashboardGroupName: row.dashboardGroupName,
          organizationId: row.organizationId,
          organizationName: row.organizationName,
          ucEnv: row.ucEnv,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.redFont {
  color: #f56c6c;
}
.form-content {
  padding: 20px 100px 0;
}
.btn-list {
  margin-left: 220px;
  margin-top: 40px;
}
.click-word {
  color: #2f70ff;
  cursor: pointer;
}
@media (min-width: 600px) {
  .el-dropdown-menu {
    left: calc(100% - 180px) !important;
  }
}
</style>
